import React, { useRef } from 'react';
import { useSubdomain } from '../../contexts/subdomain';
import logoFG from '../../assets/images/logos/fiskagroup.png';
import I18nComponentChooseLanguage from '../../components/Widgets/i18n-choose-language';

export default function Header() {
    const headerRef = useRef(null);
    const { subdomainData } = useSubdomain();

    return (
        <header ref={headerRef} className="z-50 w-full fixed top-0 transition bg-backgroundColor py-2 lg:py-4">
            <div className="mx-auto flex items-center justify-between px-2 sm:px-12 lg:pr-4 max-w-full gap-12">
                <div className="flex gap-6 items-center">
                    <a href="/">
                        <img src={logoFG} alt="Logo Fiska Group" className="h-14" />
                    </a>

                    {subdomainData?.logoUrl && (
                        <a href="/">
                            <img
                                src={subdomainData.logoUrl}
                                alt={`Logo ${subdomainData.fullName || 'partenaire'}`}
                                className="h-14 max-w-[160px] object-contain"
                            />
                        </a>
                    )}
                </div>

                <I18nComponentChooseLanguage />
            </div>
        </header>
    );
}